import React from 'react'
import './CompanyProducts.scss'

const CompanyProducts = () => {
    return (
        <div>
            CompanyProducts
        </div>
    )
}

export default CompanyProducts
